import { Container } from 'pixi.js';
import { Signal } from 'typed-signals';
import type { ResourceMap } from '../../../app/resources/types';
import { RaceChestLayout } from '../../../../layouts/raceEvent/RaceChestLayout';
import { applyLayoutState } from '../../../libs/layouts/populateLayouts/applyLayoutState';
import { RewardBubbleView } from '../../../views/RewardBubbleView';
import { SpeechBubbleSide } from '../../../views/SpeechBubbleView';
import { playLayoutAnimation } from '../../../libs/layouts/layoutAnimations/playLayoutAnimation';

export class RaceEventChestView extends Container {
  public readonly onClicked = new Signal();

  private readonly layout = new RaceChestLayout();

  private rewardBubble: RewardBubbleView | null = null;

  constructor(
    private readonly rank: number,
    private readonly rewards: ResourceMap,
  ) {
    super();

    const { root, chest } = this.layout;
    root.props({ parent: this });

    chest.on('pointertap', () => {
      this.onClicked.emit();
    });

    if (rank === 2) {
      applyLayoutState(this.layout, '2nd');
    } else if (rank === 3) {
      applyLayoutState(this.layout, '3rd');
    }
  }

  public setRewardBubbleVisible(value: boolean): void {
    if ((value && this.rewardBubble) || (!value && !this.rewardBubble)) return;

    if (!value) {
      this.rewardBubble?.destroy();
      this.rewardBubble = null;
      return;
    }

    let anchor = 0.5;

    if (this.rank === 2) {
      anchor = 0;
    } else if (this.rank === 3) {
      anchor = 1;
    }

    this.rewardBubble = new RewardBubbleView({
      pointer: { side: SpeechBubbleSide.Top, anchor },
      rewards: this.rewards,
    }).props({
      scaleXY: 1.4,
      parent: this,
    });
  }

  public async animateOpen(callback: (spawnPoint: Container, rewards: ResourceMap) => void): Promise<void> {
    await playLayoutAnimation(this.layout, 'Chest_Open', false, (event) => {
      if (event === 'changeTexture') {
        this.layout.chest.props({
          texture: `${this.layout.chest.texture.label}_Open`,
        });
      } else if (event === 'spawnGifts') {
        callback(this.layout.giftSpawnPoint, this.rewards);
      }
    });
  }
}
